export enum CouponCodeApiError {
  OneTimeCoupon = 'usage_count_mes',
  Message = 'message',
  Error = 'error',
  CouponCodeUsed = 'coupon_error',
}

export type CouponCode = {
  couponNumber: string;
  couponType: string;
  percentage: number;
  expiration: string;
  type: string;
};

export type CouponCodeRequest = {
  couponCode: string;
};

export type GetCouponCodeRequest = {
  cookie?: string;
};
